export const SET_OPINION_GRADE = 'OPINION_ENROLLMENT_REQUEST_GRADE/SET_OPINION_GRADE';
export const ADD_OPINION_GRADE = 'OPINION_ENROLLMENT_REQUEST_GRADE/ADD_OPINION_GRADE';
export const UPDATE_OPINION_GRADE = 'OPINION_ENROLLMENT_REQUEST_GRADE/UPDATE_OPINION_GRADE';
export const REMOVE_OPINION_GRADE = 'OPINION_ENROLLMENT_REQUEST_GRADE/REMOVE_OPINION_GRADE';